import {register} from '../modules/eventMap';

const copy = async (button, value) => {
    try {
        await navigator.clipboard.writeText(value);
        const parent = button.closest('[data-kui-copy-text]');
        const liveRegion = parent.querySelector('[aria-live]');

        parent.classList.add('is-active');
        if (liveRegion) liveRegion.textContent = 'Copied';

        setTimeout(() => {
            parent.classList.remove('is-active');
            liveRegion.textContent = null;
            button.focus();
        }, 2000);
    } catch (err) {
        console.error(err);
    }
};

const type = (el) => {
    const target = document.getElementById('target');
    target.textContent = el.value;
};

const write = async (el) => {
    const value = el.value;
    await copy(el, value);
};

const code = async (el) => {
    const container = el.closest('[data-code-block="true"]');
    const codeBlock = container.querySelector(
        '[data-copy-to-clipboard-target="true"]'
    );
    await copy(el, codeBlock.innerText);
};

const copyToClipboard = () => {
    register('copyToClipboard', {
        write,
        type,
        code
    });
};

export {copyToClipboard};
